module.exports = __webpack_public_path__ + "img/moondance_hair.ddfac037.jpg";